const errorMessages = {
  invalidKeyword: "Invalid keyword. Please type letters.",
  invalidIngredient:
    "Invalid ingredient. Type an ingredient(letters only) then click 'Enter' or '+'.",
  duplicate: "Ingredient already exists.",
  noAddedIngredients:
    "No ingredients have been added. Type an ingredient(letters only) then click 'Enter' or '+'.",
  noKeyword:
    "No keyword typed, Type a keyword(letters only) then click 'Search'",
  noResults: "No results found. Please try a different search.",
};

const inputGuides = {
  ingredientsInput: "Type ingredient & Enter...",
  keywordInput: "Type recipe keyword e.g. Mexican",
};

export { inputGuides, errorMessages };
